import script from "./CvDatePickerSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./CvDatePickerSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./CvDatePickerSkeleton.vue?vue&type=style&index=0&id=1da605fd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/carbon-components-vue/carbon-components-vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1da605fd"]])

export default __exports__